import { gql } from '@apollo/client';

export const CurrentUserQuery = gql`
  query me {
    authenticatedItem {
      ... on User {
        id
        email
        phoneNumber
        name
        isPhoneNumberVerified
        isBanned
        dateOfBirth
        walletBalance
        accessRestrictions {
          id
          reason
          organization {
            id
          }
        }
        stripeVerificationSession {
          status
          lastError
        }
        userParkings {
          id
          status
          parking {
            id
          }
        }
        completedQuests {
          id
          createdAt
          quest {
            id
            title
            reward
            description
            type
          }
        }
        consents {
          id
          policy {
            id
          }
        }
        organization {
          id
          name
        }
      }
    }
  }
`;
